import { render, staticRenderFns } from "./DetailGeneralKasbon.vue?vue&type=template&id=a9e8ba96"
import script from "./DetailGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./DetailGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports